import React, { createContext, useContext, useCallback, useRef, useEffect, useState } from 'react';
const SocketContext = createContext(null);
// const SOCKET_SERVER_URL = process.env.REACT_APP_WSS_DOMAIN || 'wss://gagl-api.comrex.com/api';
const SOCKET_SERVER_URL = process.env.REACT_APP_WSS_DOMAIN || 'wss://comrex-api-dev.panthermediasystem.net/api';
export const useSocket = () => {
    return useContext(SocketContext);
};
const useWebSocket = (url) => {
    const socketRef = useRef(null);
    const [lastMessage, setLastMessage] = useState();
    const [isConnected, setIsConnected] = useState(false);
    useEffect(() => {
        const ws = new WebSocket(url);
        socketRef.current = ws;
        ws.onopen = () => {
            console.log('WebSocket Client Connected');
            setIsConnected(ws.readyState === WebSocket.OPEN);
        };
        ws.onmessage = (event) => {
            console.log({ event });
            if (!event.data)
                return;
            setLastMessage(JSON.parse(event.data));
        };
        ws.onclose = () => {
            console.log('WebSocket Client Disconnected');
            setIsConnected(false);
        };
        return () => {
            console.log("Compnent rerender and close");
            ws.close();
        };
    }, []);
    setInterval(() => {
        console.log("keep alive every 50 seconds.");
        sendMessage(JSON.stringify({ type: '', room: '' }));
    }, 50000);
    const sendMessage = (msg) => {
        if (socketRef.current && isConnected) {
            socketRef.current.send(JSON.stringify(msg));
        }
    };
    return {
        lastMessage,
        sendMessage,
        isConnected,
    };
};
export const SocketProvider = ({ children }) => {
    const { sendMessage, lastMessage, isConnected, } = useWebSocket(SOCKET_SERVER_URL);
    const joinRoom = useCallback((roomId) => {
        sendMessage(JSON.stringify({ type: 'join-room', room: roomId }));
    }, [sendMessage]);
    return (React.createElement(SocketContext.Provider, { value: { joinRoom, lastMessage, isConnected, sendMessage } }, children));
};
